import React, { useEffect, useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import SHA256 from 'crypto-js/sha256';

const QRCodeDisplay = ({ cardNr, guid, deviceId, timeElapsed, setTimeElapsed }) => {
  const [qrCode, setQrCode] = useState('');
  const [iat, setIat] = useState(Math.floor(Date.now() / 1000));

  // Générer le QR code
  useEffect(() => {
    const generateQRCode = () => {
      const combined = `${cardNr}${guid}${iat}${deviceId}`;
      const sha256Hash = SHA256(combined).toString();
      const hexCode = sha256Hash.slice(0, 8).toUpperCase();
      const newQrCode = `GM2:${cardNr}:${guid}:${iat}:${hexCode}`;
      setQrCode(newQrCode);
    };

    generateQRCode();
  }, [cardNr, guid, deviceId, iat]);

  // Mettre à jour le temps écoulé et rafraîchir le QR code toutes les 5 secondes
  useEffect(() => {
    const interval = setInterval(() => {
      setTimeElapsed((prevTime) => {
        if (prevTime >= 5000) {
          setIat(Math.floor(Date.now() / 1000)); // Rafraîchir le QR code
          return 0; // Réinitialiser le temps écoulé
        }
        return prevTime + 50; // Mettre à jour le temps écoulé toutes les 50 ms
      });
    }, 50);

    return () => clearInterval(interval);
  }, [setTimeElapsed]);

  return (
    <div>
      <QRCodeSVG value={qrCode} size={256} />
      <p>{qrCode}</p>
    </div>
  );
};

export default QRCodeDisplay;